import React from 'react';
import {
  Box,
  Typography,
  Paper,
  LinearProgress,
  Tooltip,
} from '@mui/material';
import DiamondIcon from '@mui/icons-material/Diamond';

const RarityRanking = ({ score, rank, totalSupply }) => {
  // Calculate rarity percentage (inverse of rank/totalSupply)
  const rarityPercentage = ((totalSupply - rank) / totalSupply) * 100;

  const getRarityLabel = (percentage) => {
    if (percentage >= 99) return 'Legendary';
    if (percentage >= 95) return 'Mythical';
    if (percentage >= 90) return 'Epic';
    if (percentage >= 80) return 'Rare';
    return 'Common';
  };

  const getRarityColor = (percentage) => {
    if (percentage >= 99) return '#FFD700'; // Gold
    if (percentage >= 95) return '#FF44FF'; // Pink
    if (percentage >= 90) return '#A020F0'; // Purple
    if (percentage >= 80) return '#0000FF'; // Blue
    return '#00F5FF'; // Cyan
  };

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        background: 'rgba(0, 245, 255, 0.05)',
        border: '1px solid rgba(0, 245, 255, 0.1)',
        borderRadius: 2,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        <DiamondIcon sx={{ color: getRarityColor(rarityPercentage), mr: 1 }} />
        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
          Rarity Score: {score.toFixed(2)}
        </Typography>
      </Box>
      
      <Tooltip title={`Rank ${rank} of ${totalSupply}`}>
        <Box sx={{ width: '100%', mt: 1 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
            <Typography variant="body2" color="text.secondary">
              {getRarityLabel(rarityPercentage)}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Top {(rarityPercentage).toFixed(1)}%
            </Typography>
          </Box>
          <LinearProgress
            variant="determinate"
            value={rarityPercentage}
            sx={{
              height: 8,
              borderRadius: 4,
              backgroundColor: 'rgba(0, 245, 255, 0.1)',
              '& .MuiLinearProgress-bar': {
                backgroundColor: getRarityColor(rarityPercentage),
                borderRadius: 4,
              },
            }}
          />
        </Box>
      </Tooltip>
    </Paper>
  );
};

export default RarityRanking;
